<template>
  <div class="container">
    <div class="login-container">
      <div class="leftBox">
        <div class="headerBox">
          <img :src="loginIcon" alt="" srcset="" />
          微域大语言模型智能医助
        </div>
      </div>

      <div class="rightBox">
        <div class="tit">欢迎使用 微域大语言模型智能医助</div>
        <div class="tit Tip">用户登录</div>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-position="top"
        >
          <el-form-item label="手机号" prop="account">
            <el-input
              class="inputDeep"
              type="text"
              v-model="ruleForm.account"
              autocomplete="off"
              placeholder="请输入手机号"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <div class="inputDeep">
              <el-input
                class="inputDeep"
                type="password"
                v-model="ruleForm.password"
                autocomplete="off"
                placeholder="请输入密码"
                @keyup.enter.native="submitForm('ruleForm')"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button
              class="customBtn"
              type="primary"
              @click="submitForm('ruleForm')"
              >立即登录</el-button
            >
          </el-form-item>
          <div class="notRegister">
            还没有账号？去 <span @click="registerFun">注册</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import loginIcon from "@/assets/img/loginIcon.png";
import loginBg from "@/assets/img/loginBg.png";
import Vue from "vue";
// import { mapActions } from "vuex";
// import { setItem, getItem, removeItem } from "@/utils/auth"; // get token from cookie
// import { loginFun } from "@/api/requestApi.js";
import { loginFun } from "@/api/getData.js";
export default {
  name: "Login",
  data() {
    var number = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录账号"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录密码"));
      } else {
        callback();
      }
    };
    return {
      loginIcon,
      loginBg,
      login: {
        backgroundImage: "url(" + require("../../assets/img/loginBg.png") + ")",
        backgroundSize: "100%",
      },
      ruleForm: {
        account: "",
        password: "",
      },
      rules: {
        account: [{ validator: number, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    // ...mapActions(["SET_TOKEN", "setUserInfo", "setCropInfo", "setRoutes"]),
    registerFun() {
      this.$router.push("/register");
    },

    submitForm(formName) {
      this.$router.push("/");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loginFun(this.ruleForm).then((res) => {
            if (res.code == 200 && res.data) {
              sessionStorage.setItem("adminToken", res.data.access_token);
              this.$router.push({ path: "/" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.container {
  min-height: 100%;
  min-height: 100vh;
  background: rgb(243, 244, 245);
  display: flex;
  align-items: center;
  
}

.historyBox {
  margin-right: -40px;
}

.login-container {
  height: 721px;
  width: 1215px;
  overflow: hidden;
  margin: 0 auto;
  //   padding: 30px 40px;
  text-align: left;
  background: rgb(255, 255, 255);
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(70, 70, 70, 0.25);
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 405px;
    background: url("~@/assets/img/loginBg.png") center center no-repeat;
    background-size: 100% 100%;
    .headerBox {
      display: flex;
      align-items: center;
      padding: 35px 0px 0px 25px;
      box-sizing: border-box;
      img {
        margin-right: 10px;
      }
    }
  }
  .rightBox {
    flex: 1;
    padding: 150px 269px 150px 220px;
    box-sizing: border-box;
    text-align: left;
  }
  .tit {
    margin: 20px 0px;
    color: rgba(1, 1, 1, 0.8);
    font-size: 18px;
    width: 100%;
    text-align: left;
  }

  .Tip {
    font-size: 24px;
    font-weight: 600px;
  }

  .customBtn {
    width: 328px;
    height: 49px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    background: linear-gradient(
      225deg,
      rgb(1, 14, 48) 0%,
      rgb(4, 67, 148) 100%
    );
    border-radius: 10px;
  }

  .notRegister {
    font-size: 14px;
    color: rgba(1, 1, 1, 0.5);
    span {
      color: rgb(2, 38, 92);
      cursor: pointer;
    }
  }
}
</style>
